import { Fixtures } from "plos/src/components/Fixtures";
import PageTitle from "plos/src/components/PageTitle";
import { SurfaceContainer } from "plos/src/components/SurfaceContainer";
import { titleContainer } from "plos/src/styles/utils.css";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useTrackingContext } from "../../contexts/TrackingContext";
import { HelmetHead } from "../HelmetHead";
import { ContextualHelpSheet } from "../Tutorials";
import FixturesHelp from "../Tutorials/HelpPages/FixturesHelp";
import { FixturesToggle } from "./FixturesToggle";
import { fixturePage } from "./fixturesWrapper.css";

const FixturesWrapper = () => {
  const { eventId = 0 } = useParams();

  const { t } = useTranslation("fixturesAndFDR");

  const { firePageViewEvent } = useTrackingContext();

  useEffect(() => {
    firePageViewEvent("fantasy fixtures & fdr", "fixtures view");
  }, []);

  return (
    <>
      <HelmetHead
        title={t(
          "fixtures.metadata.title",
          "View Latest Premier League Fixtures | Fantasy Premier League",
        )}
        description={t(
          "fixtures.metadata.description",
          "To view the latest Gameweek fixtures and help choose your next Fantasy Premier League team, visit the official website of the Premier League.",
        )}
      />
      <ContextualHelpSheet
        title={t("contextualHelp.fixtures.title", {
          ns: "help",
          defaultValue: "How to use the Fixtures page",
        })}
      >
        <FixturesHelp />
      </ContextualHelpSheet>
      <main className={fixturePage}>
        <div className={titleContainer}>
          <PageTitle title={t("fixtures.pageTitle", "Fixtures & Results")} />
        </div>
        <FixturesToggle selected="fixtures" />
        <section>
          <SurfaceContainer>
            <Fixtures eventId={Number(eventId)} hideTitle />
          </SurfaceContainer>
        </section>
      </main>
    </>
  );
};

export default FixturesWrapper;
